module.exports = __webpack_public_path__ + "img/Honduras.647066ff.svg";